import { useState } from "react";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const cats = ["全部", "人物追踪", "来源梳理", "当事人身份", "概念辨析", "事件复盘", "人物关系", "身份核验", "心理视角"];

export default function Zixun() {
  const [cat, setCat] = useState("全部");
  const list = cat === "全部" ? articles : articles.filter((a) => a.category === cat);

  return (
    <div className="bg-background-50">
      {/* head */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-secondary-100" />
        <div className="relative mx-auto max-w-7xl px-4 py-12 md:px-6">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-700">
            <i className="ri-link-m" /> 来源与脉络
          </p>
          <h1 className="font-heading mt-3 max-w-2xl text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
            反差人物身份的来源追踪与线索梳理
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600">
            按主题归档本站关于主角、当事人身份及其来源渠道的分析文章，逐篇说明证据分级、传播时间轴与关系网络。
          </p>
        </div>
      </section>

      {/* category chips */}
      <div className="sticky top-[64px] z-30 border-y border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl gap-2 overflow-x-auto px-4 py-3 md:px-6">
          {cats.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={`shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                cat === c
                  ? "bg-primary-600 text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* list */}
      <section className="mx-auto max-w-4xl px-4 pb-14 md:px-6">
        <div className="mt-8 flex flex-col gap-5">
          {list.map((a) => (
            <Link
              key={a.id}
              to={`/zixun/${a.id}`}
              className="group rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-md bg-primary-600 px-2.5 py-0.5 text-xs text-background-50">
                  {a.category}
                </span>
                <span className="text-xs text-foreground-400">{a.date}</span>
                <span className="text-xs text-foreground-400">· 阅读 {a.reads}</span>
                <span className="text-xs text-foreground-400">· 约 {a.time}</span>
              </div>
              <h2 className="font-heading mt-3 text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                {a.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{a.excerpt}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {a.tags.map((t) => (
                  <span key={t} className="rounded-full bg-background-50 px-3 py-0.5 text-xs text-foreground-600">
                    # {t}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>

        {list.length === 0 && (
          <p className="py-16 text-center text-foreground-500">该栏目下暂无文章。</p>
        )}
      </section>
    </div>
  );
}